import { memo } from 'react';
import LogoBlue from '../../../assets/images/Logo-Blue.png';
import Logo from '../../../components/common/Logo';
import svgPaths from '../svgpaths';

/**
 * Arrow Back Icon Component
 */
const ArrowBackIcon = memo(() => (
  <div className="relative shrink-0 size-[36px]" data-name="arrow_back">
    <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 36 36">
      <g id="arrow_back">
        <mask
          height="36"
          id="mask0_1_48"
          maskUnits="userSpaceOnUse"
          style={{ maskType: 'alpha' }}
          width="36"
          x="0"
          y="0"
        >
          <rect fill="var(--fill-0, #D9D9D9)" height="36" id="Bounding box" width="36" />
        </mask>
        <g mask="url(#mask0_1_48)">
          <path d={svgPaths.p3904ef00} fill="var(--fill-0, #1C1B1F)" id="arrow_back_2" />
        </g>
      </g>
    </svg>
  </div>
));

ArrowBackIcon.displayName = 'ArrowBackIcon';

/**
 * Header component with back button and logo
 * Used across multiple screens in the reset password flow
 */
export const HeaderWithLogo = memo(({ onBackClick, backLabel = 'Back', disabled = false }) => (
  <div className="relative flex items-center justify-center mb-6 pl-6">
    <button
      className="absolute left-0 flex items-center gap-2 cursor-pointer bg-transparent border-none p-0 disabled:opacity-50"
      onClick={onBackClick}
      disabled={disabled}
      type="button"
    >
      <ArrowBackIcon />
      <span className="font-['Roboto:Regular',sans-serif] text-[16px] text-black">{backLabel}</span>
    </button>
    <Logo URL={LogoBlue} name="Janway Logo" variant="small" clickable={false} />
  </div>
));

HeaderWithLogo.displayName = 'HeaderWithLogo';
